export default __webpack_public_path__ + "static/globe-67c8a4d9c2a745b4f531a87d3f2dca62.png";